/**
 * Get the URL parameter value
 *
 * @param  str {string} 挿入したい文字列
 *         idx {int}    インデックス
 *         val {string} 挿入する文字
 * @return  res {string} 挿入後の文字列
 */
/* eslint-disable */
const strInsert = function strInsert(str, idx, val) {
  console.debug('*** Start *** strInsert')
  var res = str.slice(0, idx) + val + str.slice(idx)
  console.debug('*** End *** strInsert: ' + res)
  return res
}

export default strInsert



// WEBPACK FOOTER //
// ./src/functions/strInsert.js